import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Otp = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const navigate = useNavigate();

  const correctOtp = '123456'; // Sample OTP for demonstration

  const handleChange = (value, index) => {
    if (isNaN(value)) return; // Ignore non-numeric input

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== '' && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus(); // Move to the next input
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      const newOtp = [...otp];
      if (otp[index] === '') {
        if (index > 0) {
          document.getElementById(`otp-input-${index - 1}`).focus(); // Move to the previous input
        }
      } else {
        newOtp[index] = ''; // Clear the current input
        setOtp(newOtp);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const enteredOtp = otp.join('');

    if (otp.some((digit) => digit === '')) {
      toast.error('Please fill all the OTP boxes.');
      return;
    }

    // Validate OTP
    if (enteredOtp === correctOtp) {
      navigate('/Screen11'); // Redirect to the completed screen or next page
    } else {
      toast.error('Invalid OTP. Please try again.'); // Toast message for invalid OTP
    }
  };

  return (
    <div className="relative">
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold mb-4 text-center">Number Verification</h1>
        <p className="text-xs text-slate-500 mb-4 text-center">
          Enter the 6-digit verification code that was sent to your Phone-no.
        </p>

        <form onSubmit={handleSubmit} className="w-full max-w-sm">
          <div className="flex items-center justify-center gap-3 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="w-12 h-12 text-center text-base font-extrabold text-slate-900 bg-slate-100 border appearance-none rounded-md p-3 outline-none focus:bg-white focus:border-green-800 focus:ring-2 focus:ring-cyan-500"
                maxLength="1"
              />
            ))}
          </div>

          <button
            type="submit"
            className="w-full inline-flex justify-center mt-4 rounded-lg bg-cyan-500 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:text-black"
          >
            Verify Account
          </button>
        </form>

        <div className="text-right text-sm text-slate-500 mt-4">
          Didn't receive code?
          <a className="font-medium ml-2 text-green-600 hover:text-green-700" href="#0">
            Resend
          </a>
        </div>

        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
      </div>
    </div>
  );
};

export default Otp;
